import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const VeryBadSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#0072F5"
      fillRule="evenodd"
      d="M4.8 9v7h1.5V9H4.8Zm8 0v7h-1.5V9h1.5Z"
      clipRule="evenodd"
    />
    <path
      fill="#A1A1A1"
      fillRule="evenodd"
      d="M2.3 8a6.5 6.5 0 1 1 11.5 4.154v2.091a8 8 0 1 0-10 0v-2.091A6.474 6.474 0 0 1 2.3 8Zm6.5 6.5a6.52 6.52 0 0 0 1.5-.174v1.534a8.04 8.04 0 0 1-3 0v-1.534a6.52 6.52 0 0 0 1.5.174ZM4.585 8.365c.373-.38.891-.615 1.465-.615.574 0 1.091.235 1.464.615l1.071-1.05A3.542 3.542 0 0 0 6.05 6.25c-.993 0-1.892.409-2.536 1.065l1.071 1.05Zm6.965-.615c-.574 0-1.092.235-1.465.615l-1.07-1.05A3.542 3.542 0 0 1 11.55 6.25c.993 0 1.892.409 2.535 1.065l-1.07 1.05a2.041 2.041 0 0 0-1.465-.615ZM7.05 12h3.5a1.75 1.75 0 1 0-3.5 0Z"
      clipRule="evenodd"
    />
  </svg>
)
export default VeryBadSVG
